/**
 * DivinEssentials – Product Page JS (Final 2026)
 * Handles: gallery, mobile swipe/dots/arrows, variants, cart, description cleanup
 */
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector(".de-product");
    if (!root) return;

    var handle = root.dataset.productHandle;
    var variantId = root.dataset.variantId;
    var mainImage = document.getElementById("de-mainImage");
    var thumbs = document.getElementById("de-thumbnails");
    var qtyInput = document.getElementById("de-quantity");
    var qtyMinus = document.getElementById("de-qtyMinus");
    var qtyPlus = document.getElementById("de-qtyPlus");
    var cartBtn = document.getElementById("de-addToCart");
    var buyNowBtn = document.getElementById("de-buyNow");
    var toast = document.getElementById("de-cartConfirm");
    var toastTitle = document.getElementById("de-confirmTitle");
    var variantSelector = document.getElementById("de-variantSelector");
    var specsTable = document.getElementById("de-specsTable");

    // Mobile gallery elements
    var mainWrap = document.getElementById("de-mainWrap");
    var prevArrow = document.getElementById("de-galleryPrev");
    var nextArrow = document.getElementById("de-galleryNext");
    var counterEl = document.getElementById("de-galleryCounter");
    var dotsContainer = document.getElementById("de-galleryDots");

    // Product data — fetch once for variant switching
    var productData = null;

    function fetchProduct(cb) {
      if (productData) return cb(productData);
      fetch("/products/" + handle + ".js", { cache: "no-store" })
        .then(function (r) { return r.json(); })
        .then(function (data) { productData = data; cb(data); })
        .catch(function () {});
    }

    // ═══ GALLERY STATE ═══
    // Build image list from thumbnails for mobile navigation
    var galleryImages = [];
    var currentIndex = 0;

    function buildImageList() {
      galleryImages = [];
      if (thumbs) {
        var buttons = thumbs.querySelectorAll(".de-thumb");
        buttons.forEach(function (btn) {
          galleryImages.push({
            full: btn.dataset.full,
            alt: btn.querySelector("img") ? btn.querySelector("img").alt : ""
          });
        });
      }
    }
    buildImageList();

    var totalImages = galleryImages.length;

    // ═══ SHARED: Go to image by index ═══
    function goToImage(index, animate) {
      if (totalImages === 0) return;

      // Clamp index
      if (index < 0) index = 0;
      if (index >= totalImages) index = totalImages - 1;

      currentIndex = index;

      // Update main image
      if (mainImage && galleryImages[index]) {
        if (animate) {
          mainImage.classList.add("de-img-fading");
          setTimeout(function () {
            mainImage.src = galleryImages[index].full;
            if (galleryImages[index].alt) mainImage.alt = galleryImages[index].alt;
            mainImage.classList.remove("de-img-fading");
          }, 120);
        } else {
          mainImage.src = galleryImages[index].full;
          if (galleryImages[index].alt) mainImage.alt = galleryImages[index].alt;
        }
      }

      // Update desktop thumbnails
      if (thumbs) {
        thumbs.querySelectorAll(".de-thumb").forEach(function (t, i) {
          t.classList.toggle("active", i === index);
        });
      }

      // Update mobile dots
      if (dotsContainer) {
        dotsContainer.querySelectorAll(".de-gallery-dot").forEach(function (dot, i) {
          dot.classList.toggle("active", i === index);
        });
      }

      // Update counter
      if (counterEl) {
        counterEl.textContent = (index + 1) + "/" + totalImages;
      }
    }

    // ═══ GALLERY: Thumbnail clicks (desktop) ═══
    if (thumbs) {
      thumbs.addEventListener("click", function (e) {
        var btn = e.target.closest(".de-thumb");
        if (!btn) return;
        var idx = parseInt(btn.dataset.index, 10);
        if (!isNaN(idx)) {
          goToImage(idx, false);
        } else {
          // Fallback: use src directly
          var fullSrc = btn.dataset.full;
          if (mainImage && fullSrc) mainImage.src = fullSrc;
          thumbs.querySelectorAll(".de-thumb").forEach(function (t) {
            t.classList.remove("active");
          });
          btn.classList.add("active");
        }
      });
    }

    // ═══ MOBILE: Arrow button clicks ═══
    if (prevArrow) {
      prevArrow.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex > 0) {
          goToImage(currentIndex - 1, true);
        } else {
          // Wrap to last image
          goToImage(totalImages - 1, true);
        }
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex < totalImages - 1) {
          goToImage(currentIndex + 1, true);
        } else {
          // Wrap to first image
          goToImage(0, true);
        }
      });
    }

    // ═══ MOBILE: Dot indicator clicks ═══
    if (dotsContainer) {
      dotsContainer.addEventListener("click", function (e) {
        var dot = e.target.closest(".de-gallery-dot");
        if (!dot) return;
        var idx = parseInt(dot.dataset.index, 10);
        if (!isNaN(idx)) {
          goToImage(idx, true);
        }
      });
    }

    // ═══ MOBILE: Touch swipe on main image ═══
    if (mainWrap && totalImages > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchEndX = 0;
      var touchEndY = 0;
      var isSwiping = false;
      var swipeThreshold = 40; // minimum pixels to count as a swipe
      var swipeTimeMax = 500; // max ms for a swipe gesture
      var touchStartTime = 0;

      mainWrap.addEventListener("touchstart", function (e) {
        var touch = e.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchStartTime = Date.now();
        isSwiping = true;
      }, { passive: true });

      mainWrap.addEventListener("touchmove", function (e) {
        if (!isSwiping) return;
        var touch = e.touches[0];
        touchEndX = touch.clientX;
        touchEndY = touch.clientY;

        // Calculate deltas
        var dx = Math.abs(touchEndX - touchStartX);
        var dy = Math.abs(touchEndY - touchStartY);

        // If horizontal movement dominates, prevent vertical scroll
        if (dx > dy && dx > 10) {
          e.preventDefault();
        }
      }, { passive: false });

      mainWrap.addEventListener("touchend", function (e) {
        if (!isSwiping) return;
        isSwiping = false;

        var elapsed = Date.now() - touchStartTime;
        if (elapsed > swipeTimeMax) return;

        var dx = touchEndX - touchStartX;
        var dy = Math.abs(touchEndY - touchStartY);
        var absDx = Math.abs(dx);

        // Only register horizontal swipes (not vertical scrolls)
        if (absDx < swipeThreshold || dy > absDx) return;

        if (dx < 0) {
          // Swiped left → next image
          if (currentIndex < totalImages - 1) {
            goToImage(currentIndex + 1, true);
          } else {
            goToImage(0, true); // wrap around
          }
        } else {
          // Swiped right → previous image
          if (currentIndex > 0) {
            goToImage(currentIndex - 1, true);
          } else {
            goToImage(totalImages - 1, true); // wrap around
          }
        }

        // Reset
        touchEndX = 0;
        touchEndY = 0;
      }, { passive: true });
    }

    // ═══ QUANTITY STEPPER ═══
    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener("click", function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener("click", function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val < 99) qtyInput.value = val + 1;
      });
      qtyInput.addEventListener("change", function () {
        var val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < 1) qtyInput.value = 1;
        if (val > 99) qtyInput.value = 99;
      });
    }

    // ═══ FIX OPTION LABELS (Shopify CDN may cache old names) ═══
    if (variantSelector) {
      fetchProduct(function (product) {
        if (product.options) {
          var groups = variantSelector.querySelectorAll(".de-var-group");
          for (var i = 0; i < groups.length && i < product.options.length; i++) {
            var labelEl = groups[i].querySelector(".de-var-label");
            var strongEl = labelEl ? labelEl.querySelector("strong") : null;
            if (labelEl && product.options[i].name) {
              var selectedVal = strongEl ? strongEl.textContent : "";
              labelEl.innerHTML = product.options[i].name + ': <strong>' + selectedVal + '</strong>';
            }
          }
        }
      });
    }

    // ═══ VARIANT SELECTOR ═══
    if (variantSelector) {
      variantSelector.addEventListener("click", function (e) {
        var btn = e.target.closest(".de-var-btn");
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        // Update active state
        var group = btn.closest(".de-var-btns");
        group.querySelectorAll(".de-var-btn").forEach(function (b) {
          b.classList.remove("active");
        });
        btn.classList.add("active");

        // Update label text
        var optIndex = parseInt(btn.dataset.optionIndex, 10);
        var label = btn.closest(".de-var-group").querySelector(".de-var-label strong");
        if (label) label.textContent = btn.dataset.value;

        // Find matching variant
        fetchProduct(function (product) {
          // Gather selected options
          var selected = [];
          variantSelector.querySelectorAll(".de-var-group").forEach(function (g) {
            var activeBtn = g.querySelector(".de-var-btn.active");
            if (activeBtn) selected.push(activeBtn.dataset.value);
          });

          // Match variant
          var match = null;
          for (var i = 0; i < product.variants.length; i++) {
            var v = product.variants[i];
            var isMatch = true;
            for (var j = 0; j < selected.length; j++) {
              var optKey = "option" + (j + 1);
              // Clean comparison: remove product title prefix from variant option
              var optVal = v[optKey] || "";
              var cleanOpt = optVal;
              if (cleanOpt.indexOf(product.title) === 0) {
                cleanOpt = cleanOpt.substring(product.title.length).trim();
              }
              if (optVal !== selected[j] && cleanOpt !== selected[j]) {
                isMatch = false;
                break;
              }
            }
            if (isMatch) { match = v; break; }
          }

          if (match) {
            variantId = String(match.id);
            root.dataset.variantId = variantId;

            // Update price
            var priceEl = root.querySelector(".de-price-now");
            if (priceEl) {
              priceEl.textContent = "$" + (match.price / 100).toFixed(2);
            }

            // Update image
            if (match.featured_image && match.featured_image.src && mainImage) {
              mainImage.src = match.featured_image.src;

              // Find matching thumbnail index and sync gallery state
              if (thumbs) {
                var matchedIndex = -1;
                thumbs.querySelectorAll(".de-thumb").forEach(function (t, idx) {
                  t.classList.remove("active");
                  if (t.dataset.full && match.featured_image.src.includes(t.dataset.full.split("?")[0].split("/").pop())) {
                    t.classList.add("active");
                    matchedIndex = idx;
                  }
                });

                // Sync mobile gallery state if we found a match
                if (matchedIndex >= 0) {
                  currentIndex = matchedIndex;

                  // Update dots
                  if (dotsContainer) {
                    dotsContainer.querySelectorAll(".de-gallery-dot").forEach(function (dot, i) {
                      dot.classList.toggle("active", i === matchedIndex);
                    });
                  }

                  // Update counter
                  if (counterEl) {
                    counterEl.textContent = (matchedIndex + 1) + "/" + totalImages;
                  }
                }
              }
            }

            // Update URL
            if (window.history && window.history.replaceState) {
              var url = new URL(window.location);
              url.searchParams.set("variant", match.id);
              window.history.replaceState({}, "", url);
            }
          }
        });
      });
    }

    // ═══ CLEAN UP CJ DESCRIPTION HTML ═══
    function cleanDescriptionArea(container, isShort) {
      if (!container) return;

      // Remove embedded CJ images
      container.querySelectorAll('img[src*="cjdropshipping"], img[src*="oss-cf.cjdropshipping"]').forEach(function (el) { el.remove(); });

      // Remove scripts
      container.querySelectorAll("script").forEach(function (el) { el.remove(); });

      // Remove "Why Buy From DivinEssentials" sections
      var html = container.innerHTML;
      html = html.replace(/<h3[^>]*>Why Buy From DivinEssentials\?<\/h3>[\s\S]*?<\/ul>/gi, "");

      // Clean raw CJ data formats
      html = html.replace(/\["","([^"]+)"\]/g, "$1");
      html = html.replace(/\["([^"]+)"\]/g, "$1");
      html = html.replace(/\["([^"]*)",\s*"([^"]*)"\]/g, "$1, $2");

      // Remove "Product Image:" sections
      html = html.replace(/<b>Product Image:<\/b>[\s\S]*/gi, "");

      // Remove excessive <br>
      html = html.replace(/(<br\s*\/?>){3,}/gi, "<br>");
      html = html.replace(/^\s*(<br\s*\/?>)+/gi, "");

      // Remove empty elements
      html = html.replace(/<p>\s*<\/p>/g, "");
      html = html.replace(/<b>\s*<br\s*\/?>\s*<\/b>/g, "");
      html = html.replace(/<div class="product-description">/gi, "");

      // Clean broken nested list items
      html = html.replace(/<li>\s*<li>/g, "<li>");
      html = html.replace(/<\/li>\s*<\/li>/g, "</li>");

      container.innerHTML = html;

      // Remove empty paragraphs
      container.querySelectorAll("p").forEach(function (p) {
        if (p.textContent.trim() === "" && !p.querySelector("img")) p.remove();
      });

      // Extract specs from description and add to specs table
      if (specsTable) {
        container.querySelectorAll("h3").forEach(function (h3) {
          if (h3.textContent.trim().toLowerCase() === "specifications") {
            var specsList = h3.nextElementSibling;
            if (specsList && specsList.tagName === "UL") {
              specsList.querySelectorAll("li").forEach(function (li) {
                var strong = li.querySelector("strong");
                if (strong) {
                  var key = strong.textContent.replace(":", "").trim();
                  var val = li.textContent.replace(strong.textContent, "").trim();
                  // Skip useless specs
                  if (key === "Category" || key === "Package" || key === "Product Attributes" || !val) return;
                  // Add to specs table
                  var tr = document.createElement("tr");
                  tr.innerHTML = "<th>" + key + "</th><td>" + val + "</td>";
                  specsTable.appendChild(tr);
                }
              });
              specsList.remove();
            }
            h3.remove();
          }
        });
      }

      // For the short description: extract just the first meaningful paragraph + bullets
      if (isShort) {
        // Find all meaningful content blocks
        var blocks = [];
        var children = container.children;
        for (var i = 0; i < children.length; i++) {
          var el = children[i];
          var text = el.textContent.trim();
          if (text.length > 10) blocks.push(el);
        }

        // Also extract from raw text if no block elements
        if (blocks.length === 0 && container.textContent.trim().length > 20) {
          // Content is just text, show it all
          return;
        }
      }
    }

    // Fix "Options: Title" in specs table to use real option names
    if (specsTable) {
      fetchProduct(function (product) {
        specsTable.querySelectorAll("th").forEach(function (th) {
          if (th.textContent.trim() === "Options") {
            var td = th.nextElementSibling;
            if (td && product.options) {
              var optNames = product.options.map(function (o) { return o.name; }).join(", ");
              td.textContent = optNames + " (" + product.variants.length + " variants)";
            }
          }
        });
      });
    }

    // Clean description areas
    cleanDescriptionArea(document.getElementById("de-shortDesc"), true);
    cleanDescriptionArea(document.getElementById("de-fullDescription"), false);

    // Also extract specs data like dimensions, weight, material from description text
    var descText = (document.getElementById("de-fullDescription") || {}).textContent || "";
    if (specsTable) {
      // Try to extract common specs
      var specPatterns = [
        { regex: /(?:dimensions?|size)[:\s]+([^,.\n]+)/i, label: "Dimensions" },
        { regex: /(?:diameter)[:\s]+([^,.\n]+)/i, label: "Diameter" },
        { regex: /(?:weight|weighs)[:\s]+(?:about\s+)?([^,.\n]+)/i, label: "Weight" },
        { regex: /(?:material)[:\s]+([^,.\n]+)/i, label: "Material" },
        { regex: /(?:capacity)[:\s]+([^,.\n]+)/i, label: "Capacity" },
        { regex: /(?:battery)[:\s]+([^,.\n]+)/i, label: "Battery" },
        { regex: /(?:color|colours?)[:\s]+([^.\n]+)/i, label: "Colors" },
        { regex: /(?:power)[:\s]+([^,.\n]+)/i, label: "Power" },
      ];

      specPatterns.forEach(function (p) {
        var m = descText.match(p.regex);
        if (m && m[1]) {
          var val = m[1].trim();
          if (val.length > 2 && val.length < 100) {
            // Check if this spec already exists in table
            var exists = false;
            specsTable.querySelectorAll("th").forEach(function (th) {
              if (th.textContent.trim().toLowerCase() === p.label.toLowerCase()) exists = true;
            });
            if (!exists) {
              var tr = document.createElement("tr");
              tr.innerHTML = "<th>" + p.label + "</th><td>" + val.charAt(0).toUpperCase() + val.slice(1) + "</td>";
              specsTable.appendChild(tr);
            }
          }
        }
      });
    }

    // ═══ CART ═══
    function refreshCartCount() {
      fetch("/cart.js", { cache: "no-store" })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count || 0;
          document.querySelectorAll("#cartCount, .de-cart-badge, .de-cart-count, [data-cart-count]")
            .forEach(function (el) {
              el.textContent = count;
              el.style.display = count > 0 ? "inline-flex" : "none";
            });
        })
        .catch(function () {});
    }

    function showToast(msg) {
      if (!toast || !toastTitle) return;
      toastTitle.textContent = msg;
      toast.classList.add("show");
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.classList.remove("show"); }, 3500);
    }

    function addToCart(checkout) {
      if (cartBtn && cartBtn.disabled) return;
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;

      // ═══ CUSTOM FIELD VALIDATION & COLLECTION ═══
      var customProps = {};
      var errorEl = document.getElementById("de-customError");

      // Pet Name field (Beaded Name Set)
      var petNameInput = document.getElementById("de-petName");
      if (petNameInput) {
        var petName = petNameInput.value.trim();
        if (!petName) {
          petNameInput.style.borderColor = "#e74c3c";
          if (errorEl) errorEl.style.display = "block";
          petNameInput.focus();
          return;
        }
        petNameInput.style.borderColor = "#7c5cbf";
        if (errorEl) errorEl.style.display = "none";
        customProps["Pet Name"] = petName;
      }

      // Pet Description field (Stamp)
      var petDescInput = document.getElementById("de-petDescription");
      if (petDescInput) {
        var petDesc = petDescInput.value.trim();
        if (!petDesc) {
          petDescInput.style.borderColor = "#e74c3c";
          if (errorEl) errorEl.style.display = "block";
          petDescInput.focus();
          return;
        }
        petDescInput.style.borderColor = "#7c5cbf";
        if (errorEl) errorEl.style.display = "none";
        customProps["Pet Description"] = petDesc;
      }

      var hasProperties = Object.keys(customProps).length > 0;

      var doAdd = function (vid) {
        if (cartBtn && !checkout) {
          cartBtn.textContent = "Adding...";
          cartBtn.disabled = true;
        }

        var cartBody = { id: vid, quantity: qty };
        if (hasProperties) {
          cartBody.properties = customProps;
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cartBody)
        })
        .then(function (r) {
          if (!r.ok) throw new Error("Failed");
          return r.json();
        })
        .then(function () {
          refreshCartCount();
          if (checkout) {
            window.location.href = "/checkout";
          } else {
            showToast("Added to cart — " + qty + " item" + (qty > 1 ? "s" : ""));
            if (cartBtn) { cartBtn.textContent = "Add to Cart"; cartBtn.disabled = false; }
          }
        })
        .catch(function () {
          showToast("Error adding to cart. Try again.");
          if (cartBtn) { cartBtn.textContent = "Add to Cart"; cartBtn.disabled = false; }
        });
      };

      if (variantId) {
        doAdd(parseInt(variantId, 10));
      } else {
        fetchProduct(function (p) {
          if (p && p.variants && p.variants.length) doAdd(p.variants[0].id);
        });
      }
    }

    if (cartBtn) cartBtn.addEventListener("click", function () { addToCart(false); });
    if (buyNowBtn) buyNowBtn.addEventListener("click", function () { addToCart(true); });
  });
})();
